// removed by extract-text-webpack-plugin
module.exports = {"img":"Vimeo__img___3IcCs","videoCont":"Vimeo__videoCont___nOO17","video":"Vimeo__video___3kAK4"};


//////////////////
// WEBPACK FOOTER
// ./src/Rist/modules/Vimeo/Vimeo.css
// module id = 762
// module chunks = 0